import { render, staticRenderFns } from "./MetaDataInput.vue?vue&type=template&id=403185c4&scoped=true&"
import script from "./MetaDataInput.vue?vue&type=script&lang=ts&"
export * from "./MetaDataInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403185c4",
  null
  
)

export default component.exports